import { ShopOnboardingID } from '@prisma/client';
import PageLayout from '../components/global/PageLayout';
import PageLoading from '../components/global/PageLoading';
import PocketflowsEmbed from '../components/marketing/PocketflowsEmbed';
import useGetMarketingData from '../hooks/marketing/useGetMarketingData';
import OnboardingBanner from '../components/onboarding/OnboardingBanner';

export default function ReviewsPage() {
  const { data: marketingData, isLoading } = useGetMarketingData();

  const embedId = marketingData?.sourceEmbedId;

  return (
    <PageLayout
      withoutChildContainer
      headerIsHidden
      topSection={
        <OnboardingBanner step={ShopOnboardingID.REVIEWS} completeOnRender />
      }>
      {(isLoading || !embedId) && <PageLoading />}
      {!isLoading && embedId && (
        <PocketflowsEmbed embedId={embedId} path="reviews" title="Reviews" />
      )}
    </PageLayout>
  );
}
